import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Footer from './Footer'
import './Login.css'
import { setRoleCookies } from '../../../utils/auth'

const Login = ({setIsLogined, setSessionToken, logout}) => {
    const { t } = useTranslation();
    useEffect(() => {
        if (logout) {
            document.cookie = 'token=;max-age=0';
            setIsLogined(false);
            setSessionToken('');
        }
    }, [logout, setIsLogined, setSessionToken]);

    const { shop } = useParams();

    const [shopUserId, setShopUserId] = useState('')
    const [password, setPassword] = useState('')

    const login = () => {

        fetch(process.env.REACT_APP_API_URL + '/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: "include",
            cache: 'no-store',
        }).then((response) => {
            let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
            if (xsrfToken) {
                xsrfToken = xsrfToken.split('=')[1]
            }

            fetch(process.env.REACT_APP_API_URL + '/api/login', {
                method: 'POST',
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                    'Accept': 'application/json'
                },
                credentials: "include",
                body: JSON.stringify({
                    shop_path: shop,
                    shop_user_id: shopUserId,
                    password: password,
                }),
            }).then((response) => response.json())
            .then((data) => {
                if (data.token) {
                    // setIsLogined(true);
                    setSessionToken(data.token);
                    document.cookie = 'token=' + data.token + ';max-age=946080000;path=/';
                    setRoleCookies(data.role, data.user_type);
                    window.location.reload();
                    return;
                } else {
                    alert(t('login.error1'));
                    return;
                }
            }).catch((error) => {
                alert(t('login.error1'));
            });
        }).catch((error) => {
            alert(t('login.error2'));
        });
    }
    
    return (
        <>
            <div className="flex flex-row login-content">
                <div className="w-1/2 login-content-left">
                    <h1 className="text-center login-content-title">ORIPAL</h1>
                    <form className="login-form">
                        <label className="login-content-label">{t('login.id')}</label>
                        <input className="login-content-input-text" type="text" placeholder={t('login.id')} onChange={(e) => setShopUserId(e.target.value)}/>
                        <label className="login-content-label">{t('login.password')}</label>
                        <input className="login-content-input-text" type="password" placeholder={t('login.password')} onChange={(e) => setPassword(e.target.value)} />
                        <button type="button" className="login-button" onClick={login}>{t('login.login')}</button>
                    </form>
                    <Link to="reset-password" className="reset-password-link">{t('login.link')}</Link>
                    <Footer />
                </div>
                <div className="w-1/2 login-content-right">
                </div>
            </div>
        </>
    )
}

export default Login